import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=54d479c3&"
import script from "./HomeScreen.vue?vue&type=script&lang=js&"
export * from "./HomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=54d479c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports